module.exports = __webpack_public_path__ + "images/db00a3462e838bc0bf874bd11f488bf2-form-row--06.png";